import { render } from "./Index.vue?vue&type=template&id=70051bee&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=70051bee&lang=css&scoped=true"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70051bee"]])

export default __exports__